
export default {
    index () {
        return window.axios.get('/api/notifications');
    },
    markAsRead (id) {
        return window.axios.post('/api/notifications/' + id + '/read');
    },
}



// WEBPACK FOOTER //
// ./resources/assets/js/services/NotificationsService.js